// Messages from one author sent close together are stacked, so the avatar and
// name show once per burst.
const GROUPING_WINDOW_MS = 5 * 60 * 1000;

const AVATAR_COLORS = ['#526bb1', '#8b5cf6', '#0ea5e9', '#f59e0b', '#10b981', '#ef4444', '#ec4899', '#14b8a6'];
const HASH_MULTIPLIER = 31;
const HASH_MODULUS = 997;
const INITIALS_LENGTH = 2;

/** Up to two initials: first letters of the first two words, else the first two letters. */
export const getInitials = (name) => {
    if (!name) return '?';
    const words = name.trim().split(/\s+/);
    if (words.length > 1) return (words[0][0] + words[1][0]).toUpperCase();
    return words[0].slice(0, INITIALS_LENGTH).toUpperCase();
};

/** A stable colour per name, so a person keeps one colour across messages. */
export const getAvatarColor = (name) => {
    if (!name) return AVATAR_COLORS[0];
    let hash = 0;
    for (let i = 0; i < name.length; i += 1) {
        hash = (hash * HASH_MULTIPLIER + name.charCodeAt(i)) % HASH_MODULUS;
    }
    return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};

/** Hours and minutes in the user's locale; empty for an invalid time. */
export const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const isOwn = (message, selfName) => message.self ?? message.userInfo?.name === selfName;
const timeOf = (message) => message.time || message.receivedAt;

const startsGroup = (message, previous, selfName) => {
    if (!previous) return true;
    const time = timeOf(message);
    const previousTime = timeOf(previous);
    return isOwn(previous, selfName) !== isOwn(message, selfName)
        || previous.userInfo?.name !== message.userInfo?.name
        || !time
        || !previousTime
        || time - previousTime > GROUPING_WINDOW_MS;
};

/** Each message with whether it is the user's own, whether it starts a burst, and its time. */
export const buildRows = (messages, selfName) => messages.map((message, index) => ({
    message,
    isSelf: isOwn(message, selfName),
    startsGroup: startsGroup(message, messages[index - 1], selfName),
    timestamp: timeOf(message),
    key: `${index}-${timeOf(message) || ''}`,
}));
